module.exports = [{"id":"preload_grid","workflow":[{"id":"1","type":"start","next":{"success":"ajax"}},{"id":"ajax","type":"ajax","method":"get","data":"{}","url":"{{#with (lookup ui_json route.params.entity)}}{{get}}{{/with}}","var":"response_data","headers":"{{route.params.entity}}","next":{"success":"js","failure":"bad-alert"}},{"id":"js","type":"js","code":"function(data, ui){ui.data = (data.response_data.data)}","next":{"success":"test-js-alert","failure":"bad-alert"}}]}]


//////////////////
// WEBPACK FOOTER
// ./src/workflows/conf/grid.json
// module id = 553
// module chunks = 0